import React, {useEffect, useRef, useState} from "react";
import {useSelector} from "react-redux";
import {css} from "@emotion/react";

import {centerText, w100} from "@pg-design/helpers-css";
import {usePrevious} from "@pg-mono/hooks";
import {isEqual} from "@pg-mono/nodash";

import {IRPStore} from "../../app/rp_reducer";
import {IOSMPoisRoutesGrouped} from "../../maps/actions/fetch_osm_pois_routes_grouped";
import {IRegionListMap} from "../../region/types/IRegionListMap";
import {ViewType} from "../../view_type/ViewType";
import {useGetMapRegionsQuery} from "../map/api/get_map_region";
import {IOfferListMapOffer} from "../types/IOfferListMapOffer";
import {OSMapForOffers} from "./os_map_for_offers/OSMapForOffers";

const mapBg = require("../map/img/map_bg.jpg");

interface IProps {
    transportRoutes: IOSMPoisRoutesGrouped[] | null;
    className?: string;
    onMarkerClick: (offerId: number) => void;
    offers: IOfferListMapOffer[] | null;
    isLoading: boolean;
    isError: boolean;
    isHoliday: boolean;
    hideLayersBox?: boolean;
}

export const OfferListMap = (props: IProps) => {
    const {offers, isLoading, isError} = props;

    const selectedRegion = useSelector((state: IRPStore) => state.offerListMap.selectedRegion);
    const favouriteOffers = useSelector((state: IRPStore) => state.favourite.favourites.offers);
    const appliedOffers = useSelector((state: IRPStore) => state.offerListMap.appliedOffers.data);

    const [stateOffers, setStateOffers] = useState<IOfferListMapOffer[]>(() => {
        return offers || [];
    });
    const {data: regionData, isSuccess: isRegionRequestSucceeded} = useGetMapRegionsQuery({region: selectedRegion.map((region) => region.id)});
    const [stateRegionData, setStateRegionData] = useState<IRegionListMap[]>(regionData?.results || []);

    const prevRegionRequestState = usePrevious(isRegionRequestSucceeded, isRegionRequestSucceeded);
    const prevOfferIds = useRef<number[]>([]);

    useEffect(() => {
        const currentOfferIds = offers?.map((offer) => offer.id).sort() || [];
        const offersChanged = !isEqual(prevOfferIds.current, currentOfferIds);
        const regionChanged = prevRegionRequestState !== isRegionRequestSucceeded;
        const offersSuccess = !isLoading && !isError;

        if (props.isHoliday && offersSuccess && offersChanged) {
            setStateOffers(offers || []);
            setStateRegionData(regionData?.results || []);
            prevOfferIds.current = currentOfferIds;
        }

        if (!props.isHoliday && offersSuccess && isRegionRequestSucceeded && (offersChanged || regionChanged)) {
            setStateOffers(offers || []);
            setStateRegionData(regionData?.results || []);
            prevOfferIds.current = currentOfferIds;
        }
    }, [props.isHoliday, isLoading, isError, isRegionRequestSucceeded, offers, regionData, prevRegionRequestState]);

    const markersLength = props.offers?.length || 0;

    return (
        <>
            {(!markersLength || isError) && (
                <div css={emptyListMap}>
                    <section css={centerText}>
                        <div css={[w100, centerText]}>
                            {isError ? (
                                <h1>
                                    Błędne parametry szukania.
                                    <br /> Popraw błędy i spróbuj ponownie
                                </h1>
                            ) : (
                                <h1>
                                    Nie znaleziono ofert spełniających wybrane kryteria.
                                    <br /> Rozszerz lub zmień parametry szukania i spróbuj ponownie.
                                </h1>
                            )}
                        </div>
                    </section>
                </div>
            )}

            <OSMapForOffers
                transportRoutes={props.transportRoutes}
                viewType={ViewType.OFFER_LIST_MAP}
                onMarkerClick={props.onMarkerClick}
                offers={stateOffers}
                regionData={stateRegionData}
                favouriteOffers={favouriteOffers}
                appliedOffers={appliedOffers}
            />
        </>
    );
};

const emptyListMap = css`
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    background-image: url(${mapBg});
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 2rem;
`;
import React, {useEffect, useRef, useState} from "react";
import {useSelector} from "react-redux";
import {css} from "@emotion/react";

import {centerText, w100} from "@pg-design/helpers-css";
import {usePrevious} from "@pg-mono/hooks";
import {isEqual} from "@pg-mono/nodash";

import {IRPStore} from "../../app/rp_reducer";
import {IOSMPoisRoutesGrouped} from "../../maps/actions/fetch_osm_pois_routes_grouped";
import {IRegionListMap} from "../../region/types/IRegionListMap";
import {ViewType} from "../../view_type/ViewType";
import {useGetMapRegionsQuery} from "../map/api/get_map_region";
import {IOfferListMapOffer} from "../types/IOfferListMapOffer";
import {OSMapForOffers} from "./os_map_for_offers/OSMapForOffers";

const mapBg = require("../map/img/map_bg.jpg");

interface IProps {
    transportRoutes: IOSMPoisRoutesGrouped[] | null;
    className?: string;
    onMarkerClick: (offerId: number) => void;
    offers: IOfferListMapOffer[] | null;
    isLoading: boolean;
    isError: boolean;
    isHoliday: boolean;
    hideLayersBox?: boolean;
}

export const OfferListMap = (props: IProps) => {
    const {offers, isLoading, isError} = props;

    const selectedRegion = useSelector((state: IRPStore) => state.offerListMap.selectedRegion);
    const favouriteOffers = useSelector((state: IRPStore) => state.favourite.favourites.offers);
    const appliedOffers = useSelector((state: IRPStore) => state.offerListMap.appliedOffers.data);

    const [stateOffers, setStateOffers] = useState<IOfferListMapOffer[]>(() => {
        return offers || [];
    });
    const {data: regionData, isSuccess: isRegionRequestSucceeded} = useGetMapRegionsQuery({region: selectedRegion.map((region) => region.id)});
    const [stateRegionData, setStateRegionData] = useState<IRegionListMap[]>(regionData?.results || []);

    const prevRegionRequestState = usePrevious(isRegionRequestSucceeded, isRegionRequestSucceeded);
    const prevOfferIds = useRef<number[]>([]);

    useEffect(() => {
        const currentOfferIds = offers?.map((offer) => offer.id).sort() || [];
        const offersChanged = !isEqual(prevOfferIds.current, currentOfferIds);
        const regionChanged = prevRegionRequestState !== isRegionRequestSucceeded;
        const offersSuccess = !isLoading && !isError;

        if (props.isHoliday && offersSuccess && offersChanged) {
            setStateOffers(offers || []);
            setStateRegionData(regionData?.results || []);
            prevOfferIds.current = currentOfferIds;
        }

        if (!props.isHoliday && offersSuccess && isRegionRequestSucceeded && (offersChanged || regionChanged)) {
            setStateOffers(offers || []);
            setStateRegionData(regionData?.results || []);
            prevOfferIds.current = currentOfferIds;
        }
    }, [props.isHoliday, isLoading, isError, isRegionRequestSucceeded, offers, regionData, prevRegionRequestState]);

    const markersLength = props.offers?.length || 0;

    return (
        <>
            {(!markersLength || isError) && (
                <div css={emptyListMap}>
                    <section css={centerText}>
                        <div css={[w100, centerText]}>
                            {isError ? (
                                <h1>
                                    Błędne parametry szukania.
                                    <br /> Popraw błędy i spróbuj ponownie
                                </h1>
                            ) : (
                                <h1>
                                    Nie znaleziono ofert spełniających wybrane kryteria.
                                    <br /> Rozszerz lub zmień parametry szukania i spróbuj ponownie.
                                </h1>
                            )}
                        </div>
                    </section>
                </div>
            )}

            <OSMapForOffers
                transportRoutes={props.transportRoutes}
                viewType={ViewType.OFFER_LIST_MAP}
                onMarkerClick={props.onMarkerClick}
                offers={stateOffers}
                regionData={stateRegionData}
                favouriteOffers={favouriteOffers}
                appliedOffers={appliedOffers}
            />
        </>
    );
};

const emptyListMap = css`
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    background-image: url(${mapBg});
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 2rem;
`;
